//ユーザ登録のトップページ
import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from "yup";
import { TitleParamContext } from '../../context/TitleContext';
import { HttpPostData, JumpPage } from '../../common/Util';
import { ResponseParamBase } from '../../common/Types';
import { emailValidateion, passwordValidateion, userNameValidation } from "../../common/Valitation";
import { OnsiteTextField } from "../../customelements/CustomInput";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";

export interface IFormInputs {
    eMail: string,
    password: string,
    confirmPassword: string,
    userName: string
}

export type ResponseParam = ResponseParamBase & {
    messageList: string[],
}

const schema = Yup.object({
    eMail: emailValidateion,
    password: passwordValidateion,
    confirmPassword: passwordValidateion,
    userName: userNameValidation,
}).required();

export const RegisterUser = () => {
    const location = useLocation();
    const titleConext = useContext(TitleParamContext);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [errorMessageList, setErrorMessageList] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { eMail, password, confirmPassword, userName } = location.state as IFormInputs;

    const { handleSubmit, control, watch, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            userName: userName,
            eMail: eMail,
            password: "",
            confirmPassword: "",            
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    useEffect(() => {
        titleConext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "サポート会員情報", secondSubTitle: "（入力）" });
    }, [watch]);

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs) => {
        setErrorMessage("");
        HttpPostData<ResponseParam>("/userregister/existuser", { email: data.eMail, password: data.password, confirmPassword: data.confirmPassword, username: data.userName }, setIsLoading)
            .then(response => {

                if (response.data.resultFlg) {
                    JumpPage<IFormInputs>("/consentform/registeruser/confirm", data, "", navigate);
                } else {
                    setErrorMessage(response.data.message);
                    setErrorMessageList(response.data.messageList);
                }

                return response.data;
            })
            .catch(error => {
                setErrorMessage("仮登録処理中にエラーが発生しました。");
            });

    };

    const navigate = useNavigate();

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    <p className={base.messageFont}>登録するサポート会員情報を入力してください。</p>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputLongTitle}>
                                <h3>利用者(会社名または個人名)</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="userName"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            error={errors.userName ? true : false}
                                            helperText={errors.userName?.message}
                                            margin="normal"
                                            type="text"
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputLongTitle}>
                                <h3>メールアドレス</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="eMail"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            error={errors.eMail ? true : false}
                                            helperText={errors.eMail?.message}
                                            margin="normal"
                                            type="email"
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputLongTitle}>
                                <h3>パスワード</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="password"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            error={errors.password ? true : false}
                                            helperText={errors.password?.message}
                                            margin="normal"
                                            type="password"
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputLongTitle}>
                                <h3>パスワード（確認用）</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="confirmPassword"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            error={errors.confirmPassword ? true : false}
                                            helperText={errors.confirmPassword?.message}
                                            margin="normal"
                                            type="password"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        {
                            errorMessageList?.map((field, index) => {
                                return (
                                    <div className={base.errorMessage}>{field}</div>
                                )
                            })
                        }
                        <div className={market.marketFooterArea}>
                            <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage("/ConsentForm", {}, "", navigate); }}>戻る</button>
                            <button className={market.marketButton} type="submit" disabled={!isValid || isLoading}>登録確認</button>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton}>次へ</button>
                        </div>
                    </form>                    
                </div>
            </section>
        </>
    );
}